/// <reference path='../_all.ts' />

module editor {
  'use strict';

  export enum ContentType {
    HTML = "H",
    MarkDown = "M" 
  }

  export class Content {
    constructor(

      public Content: string,
      public ContentType: ContentType, 
      public ContentMeta: ContentMeta,
      public ContentFilter: EditorFilter,
      public Excerpt: string,
      public ContentHtml?: string,
      public ExcerptHtml?: string
      ) { }
  }


}